import React from "react";
import { HeaderData } from "../../constants/interfaces";
import { Button } from "react-bootstrap";

interface HeaderProps {
  data: HeaderData
}

export const Header = (props: HeaderProps) => {
  return (
    <header id="header">
      <div className="intro">
        <div className="overlay">
          <div className="container">
            <div className="row">
              <div className="col-md-8 col-md-offset-2 intro-text">
                <h1>
                  {props.data ? props.data.title : "Loading"}
                  <span></span>
                </h1>
                <p>{props.data ? props.data.paragraph : "Loading"}</p>
                <div style={{ display: 'flex', gap: '16px' , justifyContent: 'center'}}>
                  <Button variant="outline-primary" size="lg" style={{color: '#ffffff', backgroundColor: '#0573e8', fontWeight: 'bold'}} href="/projects">
                    Our Work
                  </Button>{' '}
                  <Button variant="outline-primary" size="lg" style={{color: '#ffffff', backgroundColor: '#0573e8', fontWeight: 'bold'}} href="/apply">
                    Apply
                  </Button>{' '}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
